<div class='doc-card'>
  <div class='doc-card-title-container'>
    <span class='doc-card-title'>{{ 'SHARED.DOCUMENTARY_PROOF_CARD.DOC_NUMBER' | translate }}{{ index + 1 }}</span>
    <div class='doc-card-title-space'></div>
    <ap-button-icon-select class='doc-card-title-close' [index]='1' [isSelect]='isSelectedCheck(1)' icon='close' (select)='selectCheckDocProof($event)'></ap-button-icon-select>
    <ap-button-icon-select class='doc-card-title-check' [index]='2' [isSelect]='isSelectedCheck(2)' icon='check' (select)='selectCheckDocProof($event)'></ap-button-icon-select>
  </div>
  <dl class='dl-horizontal'>
    <dt>{{ 'SHARED.DOCUMENTARY_PROOF_CARD.TYPE' | translate }}</dt>
    <dd>{{ 'DOCUMENTARY_PROOF.REFERENCE.' + documentaryProof?.type | translateIfExist: documentaryProof?.type | noData }}</dd>

    <dt>{{ 'SHARED.DOCUMENTARY_PROOF_CARD.REFERENCE' | translate }}</dt>
    <dd>{{ documentaryProof?.reference | noData }}</dd>

    <dt>{{ 'SHARED.DOCUMENTARY_PROOF_CARD.STATUS' | translate }}</dt>
    @if (documentaryProof?.status && documentaryProof.status != DocumentaryProofStatusEnum.AWAITING_VALIDATION) {
      <dd><status-label type='DOCUMENTARY_PROOF' [status]='documentaryProof?.status'></status-label></dd>
    }
    @if (!documentaryProof?.status || documentaryProof.status == DocumentaryProofStatusEnum.AWAITING_VALIDATION) {
      <dd>-</dd>
    }

    <dt>{{ 'SHARED.DOCUMENTARY_PROOF_CARD.EXPIRATION_LABEL' | translate }}</dt>
    <dd>{{ documentaryProof?.expirationDate | date: 'dd/MM/yyyy' | noData }}</dd>

    <dt>{{ 'SHARED.DOCUMENTARY_PROOF_CARD.ISSUED_ON' | translate }}</dt>
    <dd>{{ documentaryProof?.issueDate | date: 'dd/MM/yyyy' | noData }}</dd>

    <dt>{{ 'SHARED.DOCUMENTARY_PROOF_CARD.ISSUED_AT' | translate }}</dt>
    <dd>{{ documentaryProof?.issueLocation | noData }}</dd>

    <dt>{{ 'SHARED.DOCUMENTARY_PROOF_CARD.DESCRIPTION' | translate }}</dt>
    <dd>{{ documentaryProof?.description | noData }}</dd>
  </dl>
  @for (docFile of documentaryProof.documentaryProofFiles; track docFile; let indexFile = $index) {
    <div class='form-horizontal form-label-left'>
      <div class='row flex-box'>
        <div class='flex-left doc-file-container'>{{ 'SHARED.DOCUMENTARY_PROOF_CARD.FILE_NUMBER' | translate }}{{ indexFile + 1 }}</div>
        <div class='flex-right'><ap-button-icon-select [index]='indexFile' [isSelect]='isSelectedFile(docFile.documentaryProofFileId)' icon='eye' (select)='selectDocFile(docFile.documentaryProofFileId, indexFile)'></ap-button-icon-select></div>
      </div>
    </div>
  }
</div>
